/* @flow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';
// $FlowIgnore
import { Link } from 'react-router';

export default function HomeLink({
  children, style, customDataTestID
}: Object): React.Element {
  return (
    <Link data-testid={customDataTestID} to="/" style={{...style}}>
      {children}
    </Link>
  );
}
